import { ReducerRegistry } from 'store';
import {
  SET_PRODUCT_DETAILS,
  UPDATE_STEP,
  RESET_NEW_PRODUCT,
  SET_PRODUCT_FIELDS,
  EDIT_PRODUCT_FIELDS,
  DELETE_PRODUCT_FIELDS,
  NEW_PRODUCT_ASYNC_START,
  FETCH_EDIT_PRODUCT_START,
  SET_EDIT_PRODUCT_DETAILS,
  SET_UPDATING_EDIT,
  SET_PRODUCT_CONFIGURATION,
  ADD_MULTIPLE_FIELDS,
  FETCH_BUSINESS_SECTORS,
  FETCH_BUSINESS_SECTORS_ERROR,
  FETCH_BUSINESS_CATEGORIES,
} from '../types';

const INITIAL_STATE = {
  details: {
    title: '',
    description: '',
    category: '',
    icon: '',
    imageBase64Encoded: '',
    businessSectorId: null,
  },
  fields: {},
  tempFields: {},
  configuration: {
    lookupRequired: false,
    tokenRequired: false,
    tokenVerificationUrl: '',
    lookupUrl: '',
    callBackUrl: '',
    phoneNumber: '',
  },
  editInfo: null,
  step: 1,
  loading: false,
  isFetching: false,
  isUpdating: false,
  businessSectors: [],
  businessCategories: [],
};

export const newProductReducer = ReducerRegistry.register(
  'newProduct',
  (state = INITIAL_STATE, { type, error, payload }) => {
    switch (type) {
      case SET_PRODUCT_DETAILS:
        return {
          ...state,
          details: {
            ...state.details,
            ...payload,
          },
        };
      case SET_PRODUCT_FIELDS:
        return {
          ...state,
          fields: {
            ...state.fields,
            [payload.key]: payload.values,
          },
        };
      case ADD_MULTIPLE_FIELDS:
        return {
          ...state,
          fields: {
            ...state.fields,
            ...payload,
          },
        };
      case EDIT_PRODUCT_FIELDS:
        return {
          ...state,
          fields: {
            ...state.fields,
            [payload.key]: {
              ...state.fields[payload.key],
              ...payload.values,
            },
          },
        };
      case DELETE_PRODUCT_FIELDS:
        const fields = { ...state.fields };
        delete fields[payload.key];
        return {
          ...state,
          fields: {
            ...fields,
          },
        };
      case NEW_PRODUCT_ASYNC_START:
        return {
          ...state,
          loading: payload,
        };
      case UPDATE_STEP:
        return {
          ...state,
          step: payload,
        };
      case RESET_NEW_PRODUCT:
        if (payload.resetData) return { ...state, ...payload.resetData };
        return {
          ...INITIAL_STATE,
        };
      case FETCH_EDIT_PRODUCT_START:
        return {
          ...state,
          isFetching: payload,
        };
      case SET_EDIT_PRODUCT_DETAILS:
        return {
          ...state,
          isFetching: false,
          fields: payload.fields,
          details: payload.details,
          editInfo: payload.editInfo,
          configuration: {
            ...state.configuration,
            callBackUrl: payload.editInfo.callbackUrl
              ? payload.editInfo.callbackUrl
              : '',
          },
        };

      case SET_UPDATING_EDIT:
        return {
          ...state,
          loading: payload,
        };
      case SET_PRODUCT_CONFIGURATION:
        return {
          ...state,
          configuration: {
            ...state.configuration,
            ...payload,
          },
        };
      case FETCH_BUSINESS_SECTORS:
        return { ...state, businessSectors: payload };
      case FETCH_BUSINESS_SECTORS_ERROR:
        return {
          ...state,
          error: error || 'Sorry, something went wrong. Please try again',
        };
      case FETCH_BUSINESS_CATEGORIES:
        return {
          ...state,
          businessCategories: payload,
        };
      default:
        return state;
    }
  }
);
